import { otherDocsContractTypes } from "../../../Common/commondata/commonData";
import { formatPhoneNumber } from "../../../Common/utils/universalFuntions";

const buildSignatureBlocks = ({ signers, type, rootDocData, requiredOpenFor, signerFields = {} }) => {
  if (!Array.isArray(signers)) {
    console.log("Unable to build signature block for", signers);
    return "";
  }
  // const { contractType, builtForId } = rootDocData;
  let signerType;
  if (type === "Buyers") {
    signerType = "Buyer";
  } else if (type === "Sellers") {
    signerType = "Seller";
    if (rootDocData?.contractType === "ERTL") signerType = "Landlord";
    if (rootDocData?.contractType === "ETCT") signerType = "Tenant";
  } else {
    signerType = type;
  }

  const isDWRAndSeller = rootDocData?.contractType === "DWR" && signerType === "Seller";
  const signerTitleCriteria = signerType === "Authorized" && ["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType)

  let html = "";
  signers.forEach((element) => {
    if (element.isCorp) {
      element.signers.forEach((signer, signerIndex) => {
        const isActiveSigner = signer.personId === rootDocData?.builtForId && ([...otherDocsContractTypes,"WY_RLC"].includes(rootDocData?.contractType) || element.key === rootDocData?.key) && ([...otherDocsContractTypes,"WY_RLC"].includes(rootDocData?.contractType) || rootDocData?.openFor === requiredOpenFor) && rootDocData?.signable && !rootDocData?.checkForDisable?.disabled;
        const signerStatus = isActiveSigner ? "active-signer clickable" : "inactive-signer";
        const signerId = `${requiredOpenFor}_${signer.personId}_key_${element.key}${signerFields.labelType ? `_${signerFields.labelType}` : ""}`;
        const editIconDataAttr = type === "Buyers" ? "data-buyer-details-edit-icon" : type === "Sellers" ? "data-seller-details-edit-icon" : "";
        const manualLayouts = signerFields.signatureLayout || [];
        // console.log("manualLayouts", manualLayouts, signer);
        if (manualLayouts[signerIndex]) {
          html += manualLayouts[signerIndex];
        }
      

        html += `
          <div class="signature-block">
            <table class="mt">
              <thead></thead>
              <tbody>
                <tr>
                  <td style="width: 80%;" class="border-bottom-input" id="${signerId}">
                    <div class="signature-block ${signerStatus}" data-signerId="${signer.personId}" data-signerKey="${element.key}" data-signer-labelType="${element.labelType || ""}"></div>
                  </td>
                  <td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureDate="${signerId}"></td>
                  ${signerFields?.time ? `<td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureTime="${signerId}"></td>` : ''}
                </tr>
                <tr>
                  <td>${isDWRAndSeller ? "Signature: " : signerFields.signatureLabel ? signerFields.signatureLabel.trim() + " " : `${signerType}'s Signature: `}<span class="ua tb">${element.fullName || ""}</span>  ${
          signerFields.email
            ? `
                <i class="bi bi-pencil-square no-print clickable" data-corp-signer  ${editIconDataAttr} data-signer-personId="${signer.personId}" data-signer-uuid-key="${element.key}"  data-signer-fields='${JSON.stringify(signerFields)}' style="color: blue"></i>`
            : ""
        } <br>${signer.fullName ? "Signer: " : ""} <span class="ua tb" data-signerFullName="${signerId}">${signer.fullName || ""}</span>${signer.title ? `, <span class="ua tb">${signer.title}</span>` : ""}</td>
                  
                  <td>Date</td>
                  ${signerFields?.time ? `<td>Time</td>` : ''}
                </tr>
               <table class="tableWidth" style="border: 0;">
                ${signerFields.address ? `<tr><td style="width: 30%;">${signerFields?.addressLabel || "Address:"} <span class="ua">${signer.address || ""}</span></td></tr>` : ""}
                ${signerFields.phoneNumber ? `<tr ><td>${signerFields?.phoneNumberLabel || "Phone No.:"} <span class="ua">${formatPhoneNumber(signer.phoneNumber)}</span></td></tr>` : ""}
                ${signerFields.faxNumber ? `<tr><td>${signerFields?.faxNumberLabel || "Fax No.:"} <span class="ua">${formatPhoneNumber(signer.faxNumber)}</span></td></tr>` : ""}
                ${signerFields.email ? `<tr ><td>${signerFields?.emailLabel || "Email Address:"} <span class="ua">${signer.email || ""}</span></td></tr>` : ""}
            </table>
              </tbody>
            </table>
          </div>`;
      });
    } else {
      const uuidKey = element.key || element.personId;
      const personId = element.personId || element._id || requiredOpenFor;
      const personKey = rootDocData.personKey;
      const isActiveSigner = ([...otherDocsContractTypes,"WY_RLC"].includes(rootDocData?.contractType) || rootDocData?.openFor === requiredOpenFor) && !rootDocData?.checkForDisable?.disabled && ((personId === rootDocData?.builtForId && personKey === rootDocData?.key) || (requiredOpenFor === "TITLE_COMPANY" && rootDocData?.key?.trim() === element?.email?.trim() && rootDocData?.fullName?.trim() === element?.fullName?.trim())) && rootDocData?.signable;
      const signerStatus = isActiveSigner ? "active-signer clickable" : "inactive-signer";
      const signerId = `${requiredOpenFor}_${personId}_key_${uuidKey}${signerFields.labelType ? `_${signerFields.labelType}` : ""}`;
      const signatureDateId = `${requiredOpenFor}_${personId}_key_${uuidKey}${signerFields.labelType ? `_${signerFields.labelType}` : ""}`;
      const editIconDataAttr = type === "Buyers" ? "data-buyer-details-edit-icon" : (type === "Sellers" ? "data-seller-details-edit-icon" : ((type === "Authorized" && ["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType)) ? "data-title-signer-list" : ""));
      const deleteAttribute = (type === "Authorized" && ["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType)) ? "data-title-signer-delete" : "";
      const widthStyle = signerTitleCriteria ? "width: 55%;" : "width: 80%;";
      const signerTypeLabel = signerFields.signatureLabel ? signerFields.signatureLabel.trim() + " " : ["BUYER_BROKER", "SELLER_BROKER"].includes(type) ? "Broker's Name: " : isDWRAndSeller ? "Signature: " : `${signerType}${signerType === "Authorized" ? " Signer: " : `'s Signature: `}`;
      html += `
      <div class="signature-block">
        <table class="mt">
          <thead></thead>
          <tbody>
            <tr>
              <td style="${widthStyle}" class="border-bottom-input" id="${signerId}">
                <div class="signature-block ${signerStatus}" data-signerId="${personId}" data-signerKey="${uuidKey}" data-signer-labelType="${element.labelType || ""}"></div>
              </td>
              ${signerTitleCriteria ? '<td style="width: 25%; vertical-align: bottom;" class="border-bottom-input"><input id="SignerTitleField" type="text" name="SignerTitleInput" style="border-bottom: none !important;"/></td>' : ""}
              <td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureDate="${signatureDateId}"></td>
              ${signerFields?.time ? `<td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureTime="${signatureDateId}"></td>` : ''}
            </tr>
            <tr>
                <td>${signerTypeLabel}<span class="ua tb" data-signerFullName="${signerId}">${element.fullName || ""}${element.title ? `, <span class="ua tb">${element.title}</span>` : ""}</span>
                ${(["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType) && type === "Authorized") ? `<i title="Title Signer List" class="bi bi-pencil-square no-print clickable" ${editIconDataAttr} style="color: blue"></i>${element.fullName ? ` <i class="bi bi-trash3 no-print clickable" ${deleteAttribute} style="color: #178DFA"></i>`: ""}` : ""}
                ${
                  signerFields.email && !["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType)
                    ? `
                <i class="bi bi-pencil-square no-print clickable"  ${editIconDataAttr} data-signer-personId="${personId}" data-signer-uuid-key="${uuidKey}"  data-signer-fields='${JSON.stringify(signerFields)}' style="color: blue"></i>`
                    : ""
                }
              </td>
              ${signerTitleCriteria ? "<td>Title</td>" : ""}
              <td>Date</td>
              ${signerFields?.time ? `<td>Time</td>` : ''}
            </tr>
            <table class="tableWidth" style="border: 0;">
              ${signerFields.address ? `<tr><td style="width: 30%;">${signerFields?.addressLabel || "Address:"} <span class="ua">${element.address || ""}</span></td></tr>` : ""}
              ${signerFields.personalAddress ? `<tr><td style="width: 30%;">${signerFields?.personalAddressLabel || "Address:"} <span class="ua">${element.personalAddress || ""}</span></td></tr>` : ""}
              ${signerFields.phoneNumber ? `<tr ><td>${signerFields?.phoneNumberLabel || "Phone No.:"} <span class="ua">${formatPhoneNumber(element.phoneNumber)}</span></td></tr>` : ""}
              ${signerFields.faxNumber ? `<tr><td>${signerFields?.faxNumberLabel || "Fax No.:"} <span class="ua">${formatPhoneNumber(element.faxNumber)}</span></td></tr>` : ""}
              ${signerFields.email ? `<tr ><td>${signerFields?.emailLabel || "Email Address:"} <span class="ua">${element.email || ""}</span></td></tr>` : ""}
            </table>
          </tbody>
        </table>
      </div>`;
    }
  });

  return html;
};

export default buildSignatureBlocks;
